import React from 'react'
import { Modal } from 'react-bootstrap-v5';
import { KTSVG } from '../../../../_start/helpers';
import FormHistory from '../components/FormHistory';

interface ViewHistoryModalProps {
  show: boolean;
  handleClose: () => void;
}

export default function ViewHistoryModal(props: ViewHistoryModalProps) {

  return (
    <Modal
    id="kt_modal_1"
    tabIndex={-1}
    aria-hidden="true"
    dialogClassName="modal-dialog-centered h-auto"
    show={props.show}
  >
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title">Prozess Historie</h5>
        <div
          onClick={() => props.handleClose()}
          className="btn btn-icon btn-sm btn-active-light-primary ms-2"
          data-bs-dismiss="modal"
          aria-label="Close"
        >
          <KTSVG
            path="/media/icons/duotone/Navigation/Close.svg"
            className="svg-icon svg-icon-2x"
          />
        </div>
      </div>
      <div className="modal-body">
        <div className="mb-10">
          <FormHistory />
        </div>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-light"
          data-bs-dismiss="modal"
          onClick={() => props.handleClose()}
        >
          Schliessen
        </button>
      </div>
    </div>
  </Modal>
  )
}
